const MAINTENANCE_MODE_KEY = "maintenance_mode";
const REFRESH_INTERVAL_MINUTES = 5;

const getMaintenanceMode = (): boolean => {
  const storedItem = localStorage.getItem(MAINTENANCE_MODE_KEY);
  return storedItem ? JSON.parse(storedItem) : false;
};

const setMaintenanceModeStorage = (value: boolean): void => {
  localStorage.setItem(MAINTENANCE_MODE_KEY, JSON.stringify(value));
};

const clearMaintenanceMode = (): void => {
  localStorage.removeItem(MAINTENANCE_MODE_KEY);
};

const schedulePageRefresh = (): void => {
  const refreshIntervalMs = REFRESH_INTERVAL_MINUTES * 60 * 1000;
  setTimeout(() => {
    window.location.reload();
  }, refreshIntervalMs);
};

export { getMaintenanceMode, setMaintenanceModeStorage, clearMaintenanceMode, schedulePageRefresh };
